import { render, staticRenderFns } from "./PersonalQuestionType.vue?vue&type=template&id=2bcecf6c&scoped=true"
import script from "./PersonalQuestionType.vue?vue&type=script&lang=js"
export * from "./PersonalQuestionType.vue?vue&type=script&lang=js"
import style0 from "./PersonalQuestionType.vue?vue&type=style&index=0&id=2bcecf6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcecf6c",
  null
  
)

export default component.exports